import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { Observable } from 'rxjs';
import { MenuService } from '../menu.service';
import { MatSidenav } from '@angular/material/sidenav';
import { MenuStateService } from '../menu-state.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit, AfterViewInit {
  userEmail: string = '';
  menuData$: Observable<any[]>;
  @ViewChild('sidenav', { static: false }) sidenav!: MatSidenav;

  isSidenavOpened: boolean = true;

  hoveringLeftEdge = false;
  handleMouseMove = (event: MouseEvent) => {
    const hoverThreshold = this.isSidenavOpened ? 200 : 10; // this is in pixels

    if (event.clientX <= hoverThreshold){
      if (!this.hoveringLeftEdge){
        this.hoveringLeftEdge = true;
        this.isSidenavOpened = true;
      }
    }
    else{
      this.hoveringLeftEdge = false;
      this.isSidenavOpened = false;
    }
  }

  constructor(public menuStateService: MenuStateService, private menuService: MenuService, private router: Router) {
    this.menuData$ = this.menuService.getMenuData();
  
    this.menuService.getUserEmail().subscribe(email => {
    this.userEmail = email;
  });
  
  }


  ngOnInit(): void {
    this.menuStateService.sidenavState$.subscribe(state => {
      //this.isCondensed = state.condensed;
      this.isSidenavOpened = state.opened;
    });
    window.addEventListener('mousemove', this.handleMouseMove)
  }

  ngAfterViewInit(): void {
    if (this.sidenav) {
      setTimeout(() => {
        if (this.isSidenavOpened) {
          this.sidenav.open();
        } else {
          this.sidenav.close();
        }
      });
    }

    const currentTheme = this.menuStateService.themeState$.getValue();
    this.menuStateService.applyTheme(currentTheme);
  }

  toggleSidenav() {
    this.menuStateService.toggleSidenav();
  }

  toggleTheme(){
    this.menuStateService.toggleTheme();
  }

  signOut(){
    // let accessToken = localStorage.getItem('access_token');
    // let refreshToken = localStorage.getItem('refresh_token');
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('menuData');
    window.location.reload();
  }
}
